<template>
    <div>
        <e-dialog
                dialog-title="查看详情"
                :center-dialog-visible="viewDetailVisible"
                popup-width="900px"
                :showCloseBtn="true"
                :showBtn="false"
                @resetPopupData="handleClose">
            <tableList
                    class="margin-t20"
                    rowKey="companyId"
                    :loading="false"
                    :index-show="true"
                    :table-data="tableData"
                    :table-label="tableLabel">
            </tableList>
            <div class="pagination flex-end">
                <el-pagination
                        background
                        :page-sizes="[10, 20,50,100,200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :page-size="queryData.pageSize"
                        :total="queryData.pageTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"/>
            </div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import tableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '@/modules/projectA/api/order';

export default {
  name: "orderDetailDialog",
  components: {
    eDialog,
    tableList
  },
  props: {
    viewDetailVisible: Boolean,
    petroMallOrderId: String
  },
  data() {
    return {
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      tableData: [],
      tableLabel: [
        {label: '计量单位', param: 'baseUnitName', align: 'center', width: '110',},
        {label: '数量', param: 'quantity', align: 'center', width: '120',},
        {label: '协议编号', param: 'sinoProtocol', align: 'center', width: '180'},
        {label: '商品信息', param: 'productName', align: 'center', tooltip: true},
      ],
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.petroMallOrderSkuPage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.petroMallOrderSkuPage();
    },
    handleClose() {
      this.$emit('update:viewDetailVisible', false);
    },
    async petroMallOrderSkuPage() {
      let res = await api.petroMallOrderSkuPage({...this.queryData, petroMallOrderId: this.petroMallOrderId});
      if (res.code === '200') {
        const {records, total} = res.data;
        this.tableData = records || [];
        this.queryData.pageTotal = total || 0;
      }
    },
  },
  mounted() {
    this.petroMallOrderSkuPage();
  }
}
</script>

<style scoped lang="scss">

</style>